export const preloadedValues = {
  operIPICST: "0",
  operIPIEnquandramento: "",
  operIPIAcumulaBCICMSProprio: false,
  operIPIAcumulaBCICMSDestino: false,

};
